import { render, staticRenderFns } from "./PropertiesModal.vue?vue&type=template&id=a9b3cff8"
import script from "./PropertiesModal.vue?vue&type=script&lang=js"
export * from "./PropertiesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports